export interface PageMetadata {
  title: string;
  description: string;
}

interface PagesMetadata {
  [key: string]: PageMetadata;
}

const vendor = 'Utilities One';

const defaultMetadata = {
  title: `${vendor} | Utilities One`,
  description: 'Utilities One',
};

const pagesMetadata: PagesMetadata = {
  '/about-us': {
    title: 'Utilities One',
    description: 'Utilities One',
  },
  '/news': {
    title: 'Utilities One',
    description: 'Utilities One',
  },
  '/projects': {
    title: 'Utilities One',
    description: 'Utilities One',
  },
  '/careers': {
    title: 'Utilities One',
    description: 'Utilities One',
  },
  '/contact-us': {
    title: 'Utilities One',
    description: 'Utilities One',
  },
};

const getPageMetadata = (pathname: string): PageMetadata => {
  const routes = Object.keys(pagesMetadata);
  for (const route of routes) {
    if (new RegExp(route).test(pathname)) {
      return {
        ...pagesMetadata[route],
        title: `${vendor} | ${pagesMetadata[route].title}`,
      };
    }
  }
  return defaultMetadata;
};

export default getPageMetadata;
